import Select from "react-select";

const SelectSearch = ({ Label, options, value, onChange, errors }) => {
  return (
    <div className="form-group">
      <label>{Label}</label>
      <Select
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: state.isFocused ? "none" : "none",
            borderCollapse: state.isFocused ? "transparent" : "transparent",
            paddingTop: 2,
            paddingBottom: 2,
          }),
        }}
        className="form-control p-0"
        options={options}
        value={options.find((opt) => opt.value === value) || null}
        onChange={(selected) => onChange(selected?.value)}
      />
      {errors?.message && <p className="text-danger">{errors.message}</p>}
    </div>
  );
};

export default SelectSearch;
